import React from 'react';
import { Datagrid, TextField } from 'react-admin';
import TList from '../../components/wrapper/TList';

const CurrencyList = props => (
	<TList exporter={false} actions={null} {...props}>
		<Datagrid>
			<TextField source="currencyCode" sortable={false} />
			<TextField source="name" sortable={false} />
			<TextField source="description" sortable={false} />
			<TextField source="defaultFormatString" sortable={false} />
			<TextField source="decimalOffset" sortable={false} />
		</Datagrid>
	</TList>
);

export default CurrencyList;
